module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/accessories-77c55f0c5c66e63e7ba986140f61187a.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/accessories.svg
// module id = wjQx
// module chunks = 24